<template>
<b-form>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>          
            <ECMConnectionModal v-model="showECMConnectionModal" :existingNames="paramSets" ref="ecmConnectionModal" /> 
            <ECMConfirmDialog ref="confirmationDlg" v-model="confirmationDlg"/>
        </b-row>
    </b-col>
</b-row>
<b-row class="row no-gutters">
            <b-col class="col-auto col">
                <b-nav>
                    <b-nav-item v-for="action in globalActions" @click.prevent="onGlobalAction(action)" :key="action.name">
                        <otif-icon :icon="action.name" :label="action.label" :title="action.label" key="action.name"/>
                    </b-nav-item>
                </b-nav>
            </b-col>
            
        </b-row>
        <b-row>
            <b-col v-if="paramSets.length === 0">
                <span class="OTtableJobType"><p> {{ecmResourceStrings.txtConnectionsNotDefined}}</p>
                    <otif-icon icon="information"/>
                </span >
            </b-col>
             <b-col v-else>
                <ecmconnection-select
                    v-model="$v.selectedSet"
                    v-bind:label="ecmResourceStrings.lblECMConnections"
                    :parameters="paramSets"
                    :selectedSet="selectedSet"
                    ref="params_selector"
                    :description="ecmResourceStrings.tipECMConnection"
                    v-bind:invalidMessage="ecmResourceStrings.msgECMConnectionRequired"
                    @reselected="reselected"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <template v-if="loaded === false">
                    <div class="OTloading">
                        <div class="OTloader"></div>
                    </div>
                </template>
                <template v-else-if="loaded === true && paramSets.length === 0">
                   
                </template>
               <SettingsTable v-else
                    :rows="selectedParameters"
                    :columns="columns"
                    :validations="tableValidations"
                    :customOptions="customOptions"
                    :formcolumn="'3'"
                    @save="save">
                    <template slot="table-header">
                        <h1 class="text-center OT-table-title">
                          {{selectedName}}
                        </h1>
                    </template>
                </SettingsTable>
            </b-col>
        </b-row>
        </b-form>
</template>

<script>

import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { numericval } from '../../../utils/validatorECM.js';
import { showMessage } from '../../../utils/commonECM.js';
import OtifGlobalActions from '../../../../../../mtm-studio-components/src/components/table/GlobalActions.vue';
import SettingsTable from '@/ecm/components/ECMParametersTable.vue';
import EcmRepositoryConnections from '../../../../ecm/components/widgets/ECMRepositoryConnections.vue';
import ECMConnectionModal from '../../modals/ECMCreateConnection.vue';
import ECMConfirmDialog from '../../modals/ECMCrawlerConfirmDlg.vue';
import { showConfirmationDialog } from '../../../utils/commonECM.js';
import StatusColumn from '../../links/ecmmandatorystatus.vue';
import { connectionsettings } from '../../../utils/validatorECM.js';
import axios from 'axios';

export default {

    props: ['selectedECMType', 'ecmRepository', 'parametersFromGrammar', 'realParametersConfigurations' , 'availableParametersConfigurations'],
    
    components: {
        ECMErrorDialog,
        OtifGlobalActions,
        SettingsTable,
        ECMConnectionModal,
        'ecmconnection-select': EcmRepositoryConnections,
        ECMConfirmDialog,
    },
    mixins: [ validationMixin ],

    data() {
        return { 
            paramSets : [],//set of connections
            selectedSet:'0',
            selectedName:'',
            selectedParameters:[],
            fullPackage : [],
            
            lastexistingindex:-1,// see note

            loaded: false,
            messageDlg: false,
            confirmationDlg:false,
            showECMConnectionModal: false,
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            
            customOptions:  [],
            globalActions: [{
                    name: 'add',
                    label: 'Add Connection',
                    callback: () => { this.addConnection(); }
                },
                {
                    name: 'delete',
                    label: 'Delete Connection',
                    callback: () => { this.deleteConnection(); }
                },
                {
                    name: 'update',
                    label: 'Sync Classifications',
                    callback: () => { this.updateAnnotations(); }
            }],
            columns:[{
                name: 'name',
                label: 'Name',
                sortable: false,
                editable:false,
                render(row) {
                    return row.name;
                }
            },{
                name: 'type',
                label: 'Type',
                sortable: false,
                editable:false,
                render(row) {
                    return row.type;
                }
            },{
                name: 'status',
                label: '',
                sortable: false,
                editable:false,
                displayComponent:StatusColumn,
                
            },{
                name: 'value',
                label: 'Value',
                sortable: false,
                editable:true,
                render(row) {
                    return row.value;
                }
            }],
            tableValidations: {
                name:{},
                type:{},
                value: { 

                    connectionsettings
                    
                },
                status:{},
            },
        }
    },

    validations: {
        form: {

        }
    },

    computed: {
        connections(){
            return paramSets;
        }
    },

    methods: {
        
        onGlobalAction(action) {
            if (action['callback']) {
                action.callback(action);
            }
        },

        addConnection(){
            this.showECMConnectionModal = true;
        },

        createEcmConnection(conDescr){
            var that = this;
                        
            const len = that.paramSets.length;
            
            that.lastexistingindex++;
            
            var OneSet = [];
            
            for (var cnt = 0; cnt < that.fullPackage.length; cnt++)
            {
                const name  = that.fullPackage[cnt].name;
                
                if(name == 'description')
                {
                    that.realParametersConfigurations.push({"name" : that.fullPackage[cnt].name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": conDescr, "minValue" : that.fullPackage[cnt].minValue, "maxValue" :that.fullPackage[cnt].maxValue, "index": that.lastexistingindex});
                    OneSet.unshift({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : 1, "value": conDescr, "minValue" : that.fullPackage[cnt].minValue, "maxValue" :that.fullPackage[cnt].maxValue, "index": that.lastexistingindex });
                }
                else
                {
                    that.realParametersConfigurations.push({"name" : that.fullPackage[cnt].name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": that.fullPackage[cnt].value, "minValue" : that.fullPackage[cnt].minValue, "maxValue" :that.fullPackage[cnt].maxValue, "index": that.lastexistingindex});
                    OneSet.push({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": that.fullPackage[cnt].value, "minValue" : that.fullPackage[cnt].minValue, "maxValue" :that.fullPackage[cnt].maxValue, "index": that.lastexistingindex });
                }
            }
                        
            that.paramSets.push({"description":conDescr, "index":that.lastexistingindex, "setOfParameters":OneSet});
            
            if(that.paramSets.length > 0)
            {
                that.selectedSet=that.lastexistingindex;
                var cnt = 0;
                for (cnt = 0; cnt < that.paramSets.length; cnt++)
                {
                    if(that.paramSets[cnt].index == that.lastexistingindex)
                    {
                        that.selectedName=that.paramSets[cnt].description;    
                        that.selectedParameters = that.paramSets[cnt].setOfParameters;
                        break;
                    }
                }
                if(that.$refs.params_selector)
                    that.$refs.params_selector.refresh();
            }
        },

        deleteConnection(){
            var that = this;
            showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlDeleteConnection, that.ecmResourceStrings.txtDeleteConnection);
         },
        
        updateAnnotations()
        {
            this.$snotify.clear();
            var that = this;
            const shECMConnectionId=that.selectedSet;
            const shRepositoryId = this.ecmRepository.id;
            this.$snotify.async(this.ecmResourceStrings.txtUpdateAnnotationsMap, {timeout: 0});
            //const parProc = '[{ "name" : "shRepositoryId", "value" : "' + shRepositoryId + '", "type" : "int","isNull" : false}, {"name" : "shEcmConnectionId","value" : "' + shECMConnectionId + '","type" : "int","isNull" : false}]';
            //var configstring = "";
            //configstring = '{"name": "UpdatePathToIdSecondaryTypeMap", "engineName": "1", "parameters": ' + parProc + ', "asynchronousExecution": false}';
            var jsonObject = new Object([
                {
                    name:'shRepositoryId',
                    value:shRepositoryId,
                    type:'int',
                    isNull:false
                },{
                    name:'shEcmConnectionId',
                    value:shECMConnectionId,
                    type:'int',
                    isNull:false
                }
            ]);
            //const connStringPar = JSON.stringify(jsonObject); 
            var confObject = new Object(
                {
                    name:'UpdatePathToIdSecondaryTypeMap',
                    engineName:'1',
                    parameters:jsonObject,
                    asynchronousExecution:false
                });
            
            var connString = JSON.stringify(confObject); ;
            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess', connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                .then((res) => {
                    if (res.data && res.data.crawlerOperationDetails[0]) {
                        const logID = res.data.crawlerOperationDetails[0].crawlerProcessId;
                        setTimeout(that.updateAnnotationsState(logID),20000);
                    }
                })
                .catch((err) => {
                    this.$snotify.clear();
                    if(err.response)
                    {
                        this.$snotify.error(err.response.data, err.response.statusText);
                    }
                    else  if(err.message)
                    {
                        this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
                    }
                    //verify
                    that.updateAnnotationsState(0);
                });             
       },

        updateAnnotationsState(logID)
        {
            var that = this;
            axios.get('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess?ProcessName=UpdatePathToIdSecondaryTypeMap')
                .then((res) => {
                    if (res.data) {
                        this.$snotify.clear();
                        if(res.data.crawlerExecuteProcessResultsDetails)
                        {
                            var len = res.data.crawlerExecuteProcessResultsDetails.length;
                            var i = 0;var bError=false;var sRes='Finished';
                            for(i=0;i<len;i++)
                            {
                                var crawlerExecuteProcessResultsDetails = res.data.crawlerExecuteProcessResultsDetails[i];
                                if(crawlerExecuteProcessResultsDetails)
                                {
                                    var executionResultsDetails = crawlerExecuteProcessResultsDetails.executionResultsDetails;
                                    if(executionResultsDetails)
                                    {
                                        var lenRes = executionResultsDetails.length;
                                        var k=0;
                                        for(k=0;k<lenRes;k++)
                                        {
                                            var executionLogDetails = executionResultsDetails[k].executionLogDetails;
                                            if(executionLogDetails)
                                            {
                                                if(executionLogDetails.log_id == logID || executionLogDetails.parent_proc_id == logID)
                                                {
                                                    var executionExceptionDetails= executionResultsDetails[k].executionExceptionDetails;
                                                    if(executionExceptionDetails)
                                                    {
                                                        var lenIns = executionExceptionDetails.length;
                                                        if(lenIns > 0)
                                                        {
                                                            var comp = 'Details:\n';
                                                            var mess = '' ;
                                                            var t=0;
                                                            for(t=0;t<lenIns;t++)
                                                            {
                                                                comp = comp + executionExceptionDetails[t].context;
                                                                mess = mess + executionExceptionDetails[t].description;
                                                            }
                                                        }
                                                        bError=true;
                                                        showMessage(this, 'error', "Error",'', true, mess + '\n\n' + comp);
                                                        break;
                                                    }
                                                    else
                                                    {
                                                        //no exeptions
                                                        var executionStatusDetails = executionResultsDetails[k].executionStatusDetails;
                                                        if(executionStatusDetails)
                                                        {
                                                            sRes=executionStatusDetails.status;
                                                            
                                                            //this.$snotify.success(executionStatusDetails.status);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            if(bError==false)
                            {
                                this.$snotify.success(sRes);
                            }
                         }
                       
                }
            })
            .catch((err) => {
                this.$snotify.clear();
                //this.$snotify.error(err.response.data, err.response.statusText);
                showMessage(this, 'error', response.statusText, err.response.data, false, '');
            });
        },

        saveConfirmed()
        {         
            this.confirmationDlg = false;
            var that = this;
            const itemX=that.selectedSet;
            var cnt = 0;
            for (cnt = 0; cnt < that.paramSets.length; cnt++)
            {
                if(that.paramSets[cnt].index == itemX)
                {
                    const removed = that.paramSets.splice(cnt, 1);
                    break;
                }
            }

            if(that.paramSets.length > 0)
            {
                that.selectedSet=that.paramSets[0].index;
                that.selectedName=that.paramSets[0].description;
                that.selectedParameters = that.paramSets[0].setOfParameters;
                if(that.$refs.params_selector)
                    that.$refs.params_selector.refresh();  
            }
            else{
                that.selectedSet=0;
                that.selectedName='';
                that.selectedParameters=[];
            }
           
            //remove from real parameters
            cnt = 0;   
            for (cnt = that.realParametersConfigurations.length -1; cnt > -1; cnt--)
            {
                const index = that.realParametersConfigurations[cnt].index;
                if(index == itemX)   
                {
                    const removed = that.realParametersConfigurations.splice(cnt, 1);
                }
            }
        },

        reselected(value) {
            var that = this;
            that.selectedSet=value;
            for (var cnt = 0; cnt < that.paramSets.length; cnt++)
            {
                if(that.paramSets[cnt].index == value)
                {
                    that.selectedName=that.paramSets[cnt].description;    
                    that.selectedParameters = that.paramSets[cnt].setOfParameters;
                    return;
                }
            }
        },

        save(element) {
            //prevent old name just in case if for mandatory field value is empty 
            var that = this;
            var originalvalue='';
            var result = this.realParametersConfigurations.filter((el) => (el.name == element.name && el.index == element.index));
            if (result == undefined || result.length == 0)
            {
                //not found
            }
            else if (result.length == 1)
            {
                originalvalue = result[0].value;
            }

            const value = element.value;
            var configvalue = "";
            if(value.trim().length > 0)
            {
                configvalue = JSON.stringify(value); 
                //configvalue = configvalue.replace(/"/g, ""); 
                configvalue = configvalue.replace(/"/ , ""); 
                configvalue = configvalue.replace(/"$/,"");
            }
            else if(element.mandatory == 1/* && element.name == 'description'*/)
            {
                //can not be empty
                this.$snotify.clear();
                this.$snotify.error(this.ecmResourceStrings.txtErrorMandatory);
                element.value = originalvalue;
                return;
            }
            if (result[0])
            {
                //should be here
                result[0].value = element.value;
                //change description of package in set
                if(element.name == 'description')
                {
                    var cnt = 0;
                    for (cnt = 0; cnt < that.paramSets.length; cnt++)
                    {
                        if(that.paramSets[cnt].description == originalvalue)
                        {
                            that.paramSets[cnt].description = element.value; 
                            that.selectedName=that.paramSets[cnt].description;  
                            if(that.$refs.params_selector)
                                that.$refs.params_selector.refresh();

                            break;
                        }
                    }
                }
                if(element.name == 'password')
                {
                    //we already saved value in real configuration. Just for UI replace it on "*****"
                    element.value='*****';
                }
            }
        },

        initParams : function()
        {   
            var that = this;
            that.fullPackage = [];//all mandatory + available together - one whole set (prototype of set) 
            that.paramSets = [];
           
            for (var cnt = 0; cnt < that.availableParametersConfigurations.length; cnt++)
            {
                if(that.availableParametersConfigurations[cnt].name == 'description')
                {
                    that.fullPackage.unshift({
                        "name" : that.availableParametersConfigurations[cnt].name,
                        "type" : that.availableParametersConfigurations[cnt].type, 
                        "defaultvalue": that.availableParametersConfigurations[cnt].defaultvalue, 
                        "mandatory" : that.availableParametersConfigurations[cnt].mandatory, 
                        "minValue" : that.availableParametersConfigurations[cnt].minValue,
                        "maxValue" : that.availableParametersConfigurations[cnt].maxValue,
                        "value": that.availableParametersConfigurations[cnt].value});         }
                else
                {
                    var spos = 0;
                    const found = that.availableParametersConfigurations.filter(function(item) { return item.name.toUpperCase() === 'hostname'.toUpperCase(); });
                    if(found.length > 0)
                    {
                        if(that.availableParametersConfigurations[cnt].name.toUpperCase() == 'username'.toUpperCase())
                        {
                            spos = 3;
                        }
                        if(that.availableParametersConfigurations[cnt].name.toUpperCase() == 'password'.toUpperCase())
                        {
                            spos = 4;
                        }
                    }
                    else
                    {
                        if(that.availableParametersConfigurations[cnt].name.toUpperCase() == 'username'.toUpperCase())
                        {
                            spos = 1;
                        }
                        if(that.availableParametersConfigurations[cnt].name.toUpperCase() == 'password'.toUpperCase())
                        {
                            spos = 2;
                        }
                    }
                    if(spos == 0)
                    {
                        that.fullPackage.push({
                            "name" : that.availableParametersConfigurations[cnt].name,
                            "type" : that.availableParametersConfigurations[cnt].type, 
                            "defaultvalue": that.availableParametersConfigurations[cnt].defaultvalue, 
                            "mandatory" : that.availableParametersConfigurations[cnt].mandatory, 
                            "minValue" : that.availableParametersConfigurations[cnt].minValue,
                            "maxValue" : that.availableParametersConfigurations[cnt].maxValue,
                            "value": that.availableParametersConfigurations[cnt].value});
                    }
                    else
                    {
                        that.fullPackage.splice(spos, 0, {
                            "name" : that.availableParametersConfigurations[cnt].name,
                            "type" : that.availableParametersConfigurations[cnt].type, 
                            "defaultvalue": that.availableParametersConfigurations[cnt].defaultvalue, 
                            "mandatory" : that.availableParametersConfigurations[cnt].mandatory, 
                            "minValue" : that.availableParametersConfigurations[cnt].minValue,
                            "maxValue" : that.availableParametersConfigurations[cnt].maxValue,
                            "value": that.availableParametersConfigurations[cnt].value});
                    }
                }
            }
            var startindex = -1;
            var lastindex = -1;
            var OneSet = [];
            var descr = '';
            var index = -1;
            for (var cnt = 0; cnt < that.realParametersConfigurations.length; cnt++)
            {
                const name = that.realParametersConfigurations[cnt].name;
                if(startindex == -1)
                {
                    startindex = 0;
                }
                lastindex = that.realParametersConfigurations[cnt].index;
                if(that.realParametersConfigurations[cnt].index == startindex)
                {
                    if(name == 'description')
                    {
                        descr = that.realParametersConfigurations[cnt].value;
                        index = that.realParametersConfigurations[cnt].index;
                        OneSet.unshift({"name" : that.realParametersConfigurations[cnt].name, "type" : that.realParametersConfigurations[cnt].type, "defaultvalue": that.realParametersConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.realParametersConfigurations[cnt].value, "minValue" : that.realParametersConfigurations[cnt].minValue, "maxValue" :that.realParametersConfigurations[cnt].maxValue, "index": that.realParametersConfigurations[cnt].index});
                    }
                    else
                    {
                        if(name == 'password' && that.realParametersConfigurations[cnt].value != '' && that.realParametersConfigurations[cnt].value != '*****')
                        {
                            OneSet.push({"name" : that.realParametersConfigurations[cnt].name, "type" : that.realParametersConfigurations[cnt].type, "defaultvalue": that.realParametersConfigurations[cnt].defaultvalue, "mandatory" : that.realParametersConfigurations[cnt].mandatory, "value": '*****', "minValue" : that.realParametersConfigurations[cnt].minValue, "maxValue" :that.realParametersConfigurations[cnt].maxValue, "index": that.realParametersConfigurations[cnt].index});
                        }
                        else
                        {
                            OneSet.push({"name" : that.realParametersConfigurations[cnt].name, "type" : that.realParametersConfigurations[cnt].type, "defaultvalue": that.realParametersConfigurations[cnt].defaultvalue, "mandatory" : that.realParametersConfigurations[cnt].mandatory, "value": that.realParametersConfigurations[cnt].value, "minValue" : that.realParametersConfigurations[cnt].minValue, "maxValue" :that.realParametersConfigurations[cnt].maxValue, "index": that.realParametersConfigurations[cnt].index});
                        }
                    }
                }
                else
                {
                    //index was changed

                    that.paramSets.push({"description":descr, "index":index, "setOfParameters":OneSet});
                    startindex = that.realParametersConfigurations[cnt].index;
                    OneSet = [];
                    if(name == 'description')
                    {
                        descr = that.realParametersConfigurations[cnt].value;
                        index = that.realParametersConfigurations[cnt].index;
                        OneSet.unshift({"name" : that.realParametersConfigurations[cnt].name, "type" : that.realParametersConfigurations[cnt].type, "defaultvalue": that.realParametersConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.realParametersConfigurations[cnt].value, "minValue" : that.realParametersConfigurations[cnt].minValue, "maxValue" :that.realParametersConfigurations[cnt].maxValue, "index": that.realParametersConfigurations[cnt].index});
                    }
                    else
                    {
                        OneSet.push({"name" : that.realParametersConfigurations[cnt].name, "type" : that.realParametersConfigurations[cnt].type, "defaultvalue": that.realParametersConfigurations[cnt].defaultvalue, "mandatory" : that.realParametersConfigurations[cnt].mandatory, "value": that.realParametersConfigurations[cnt].value, "minValue" : that.realParametersConfigurations[cnt].minValue, "maxValue" :that.realParametersConfigurations[cnt].maxValue, "index": that.realParametersConfigurations[cnt].index});
                    } 
                }
            }
            
            if(lastindex != -1 && lastindex == startindex) //the last one
            {
                 that.paramSets.push({"description":descr, "index":index, "setOfParameters":OneSet});
            }
            if(that.paramSets.length > 0)
            {
                that.selectedSet=0;
                that.selectedName=that.paramSets[0].description;
                that.selectedParameters = that.paramSets[0].setOfParameters;
            }
            that.lastexistingindex = lastindex;
        },
        
    },
  
    mounted() {

            var breadcrumbs = [{
                name: 'settings',
                meta: { label: 'Settings' }
            },        {
                name: 'ecm-repositories',
                meta: { label: 'Repositories' }
            },{
                name: 'ecm-repo',
                meta: { label: 'Update ECM Repository' }
            }];
            this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        that.initParams();
        that.loaded = true;
    },
}
</script>